// DEPENDENCIES
//// Angular
import { createActionGroup, emptyProps, props } from '@ngrx/store';
//// Local
import { IRule } from '../../models/rule.interface';
import { deleteRuleTemplate, loadRuleTemplates } from './helpers';

export const RuleActions = createActionGroup({
    source: 'Rule',
    events: {
        loadRuleTemplates: emptyProps(),
        loadRuleTemplatesSuccess: props<{ rules: IRule[] }>(),
        addRuleTemplate: props<{ rule: IRule }>(),
        updateRuleTemplate: props<{ rule: IRule, originalRule: IRule }>(),
        deleteRuleTemplate: props<{ rule: IRule }>()
    },
});
